// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/update_cast.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { VisionCastMember } from "./vision_cast_member_pb";
import { file_vision_shotlist_v1_vision_cast_member } from "./vision_cast_member_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/update_cast.proto.
 */
export const file_vision_shotlist_v1_update_cast: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvdXBkYXRlX2Nhc3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEi1QEKEVVwZGF0ZUNhc3RSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlQ2FzdFJlcXVlc3QuUGFyYW1zEi8KC3VwZGF0ZV9tYXNrGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzaxpKCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIPCgdjYXN0X2lkGAIgASgJEgwKBG5hbWUYAyABKAkSDQoFY29sb3IYBCABKAkinwEKElVwZGF0ZUNhc3RSZXNwb25zZRJECgZyZXN1bHQYASABKAsyNC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlVwZGF0ZUNhc3RSZXNwb25zZS5SZXN1bHQaQwoGUmVzdWx0EjkKBGNhc3QYASABKAsyKy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvbkNhc3RNZW1iZXJiBnByb3RvMw", [file_google_protobuf_field_mask, file_vision_shotlist_v1_vision_cast_member]);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateCastRequest
 */
export type UpdateCastRequest = Message<"protos.vision.shotlist.v1.UpdateCastRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateCastRequest.Params params = 1;
   */
  params?: UpdateCastRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateCastRequest.
 * Use `create(UpdateCastRequestSchema)` to create a new message.
 */
export const UpdateCastRequestSchema: GenMessage<UpdateCastRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_cast, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateCastRequest.Params
 */
export type UpdateCastRequest_Params = Message<"protos.vision.shotlist.v1.UpdateCastRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string cast_id = 2;
   */
  castId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string color = 4;
   */
  color: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateCastRequest.Params.
 * Use `create(UpdateCastRequest_ParamsSchema)` to create a new message.
 */
export const UpdateCastRequest_ParamsSchema: GenMessage<UpdateCastRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_cast, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateCastResponse
 */
export type UpdateCastResponse = Message<"protos.vision.shotlist.v1.UpdateCastResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateCastResponse.Result result = 1;
   */
  result?: UpdateCastResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateCastResponse.
 * Use `create(UpdateCastResponseSchema)` to create a new message.
 */
export const UpdateCastResponseSchema: GenMessage<UpdateCastResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_cast, 1);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateCastResponse.Result
 */
export type UpdateCastResponse_Result = Message<"protos.vision.shotlist.v1.UpdateCastResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionCastMember cast = 1;
   */
  cast?: VisionCastMember | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateCastResponse.Result.
 * Use `create(UpdateCastResponse_ResultSchema)` to create a new message.
 */
export const UpdateCastResponse_ResultSchema: GenMessage<UpdateCastResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_cast, 1, 0);

